import Marquee from "react-fast-marquee";

const ITEMS = [
  "OMNI-SCORE",
  "THE DIGITAL UMPIRE",
  "L'ARBITRO DIGITALE",
  "ITTF RULES",
  "AI-POWERED",
  "SMARTER MATCHES",
];

export const Ticker = () => (
  <section
    data-testid="omni-marquee"
    className="border-y border-white/10 bg-[#0a0a0b] py-6 sm:py-8"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-4xl sm:text-6xl font-bold uppercase tracking-tight px-6 sm:px-10 ${
              i % 2 === 0 ? "text-stroke" : "text-[#f5a623]"
            }`}
          >
            {item}
          </span>
          <span className="text-[#f5a623] text-2xl sm:text-4xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
